import * as types from '../constants/ActionTypes'
import * as general from '../constants/General'
import * as status from '../constants/Status'
import { setFunctionBarType } from './layoutActions'
import { hashHistory } from 'react-router'
import * as loginActions from './loginActions'
import * as dataActions from './dataActions'
import cookie from 'react-cookie'
import * as resource from '../constants/Resources'
import { BroadcastChannel } from 'broadcast-channel';
import $ from 'jquery'

const clearState = {
  type: types.CLEAR_STATE
}

window.noninteractive = false;

export function clearCompleteState() {
  return (dispatch, getState) => {
    dispatch(loginActions.logoutUser());
    dispatch(clearState);

    cookie.remove(general.COOKIE_POS_LASTUSERID);
    cookie.remove(general.COOKIE_POS_LASTPOSID);
    
    localStorage.setItem('store', JSON.stringify(getState()));

    dispatch(getUniqueId());
    
    hashHistory.push('/login');
  }
}

function setHasFiscalPrinterUnsafe(hasFiscalPrinter) {
  return {
    type: types.SET_HAS_FISCALPRINTER,
    hasFiscalPrinter: hasFiscalPrinter
  }
}

export function setHasFiscalPrinter(hasFiscalPrinter) {
  return dispatch => dispatch(setHasFiscalPrinterUnsafe(hasFiscalPrinter))
}

function setLicenseStatusUnsafe(licensestatus) {
  return {
    type: types.SET_LICENSE_STATUS,
    status: licensestatus
  }
}

export function setLicenseStatus(licensestatus) {
  return dispatch => {
    dispatch(setLicenseStatusUnsafe(licensestatus));
  }
}

export function checkLicense(response, dispatch) {
  if (response.status === 423) {
    dispatch(setLicenseStatus(false));
  } else {
    dispatch(setLicenseStatus(true));
  }
  return response;
}

export function checkStatus(response) {
  if ((response.status >= 200 && response.status < 300) || response.status === 423 || response.status === 424) {
    return response
  }

  const error = new Error(response.statusText)
  error.response = response
  throw error
}

export function checkStatusError(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  }
  const error = new Error(response.statusText)
  error.response = response
  throw error
}

export function parseJSON(response) {
  return response.json()
}

export function setDateTime(datetime) {
  return {
    type: types.SET_DATETIME,
    datetime
  }
}

export function setPos(pos, description, postype, printReceiptInfo, displayMode, resetTime, useConfigurations, allowEmptyPrice, openingTime, closingTime, usePager, hasBlackbox) {
  return {
    type: types.SET_POS,
    pos,
    description,
    postype,
    printReceiptInfo,
    displayMode,
    resetTime,
    useConfigurations,
    allowEmptyPrice,
    openingTime,
    closingTime,
    usePager,
    hasBlackbox
  }
}

export function loadingStart() {
  return {
    type: types.LOADING_START
  }
}
export function loadingEnd() {
  return {
    type: types.LOADING_END
  }
}

export function setPreviousReceiptId(id) {
  return {
    type: types.SET_PREVIOUS_RECEIPT_ID,
    id
  }
}

function receivePaymentMethods(pos, json) {
  return {
    type: types.RECEIVE_PAYMENT_METHODS,
    pos,
    paymentMethods: json,
    receivedAt: Date.now()
  }
}

function receiveCountries(pos, json) {
  return {
    type: types.RECEIVE_COUNTRIES,
    pos,
    countries: json,
    receivedAt: Date.now()
  }
}

function receiveCustomerGroups(pos, json) {
  return {
    type: types.RECEIVE_CUSTOMERGROUPS,
    pos,
    customergroups: json,
    receivedAt: Date.now()
  }
}

function receiveLabels(pos, json) {
  return {
    type: types.RECEIVE_LABELS,
    pos,
    labels: json,
    receivedAt: Date.now()
  }
}

function fetchPaymentMethods(posid) {
  return dispatch => fetch(general.API_URL_GET_PAYMENT_METHODS + posid)
    .then(response => response.json())
    .then(json => dispatch(receivePaymentMethods(posid, json)));
}

export function getHasFiscalPrinter() {
  return (dispatch, getState) => dispatch(fetchHasFiscalPrinter(getState().generalState.devices))
}

export function fetchHasFiscalPrinter(devices) {
  return (dispatch, getState) => {
    let hasFiscalPrinter = false;
    if(devices.length > 0){
      hasFiscalPrinter = devices.some((device) => device.printertype ===  600);
    }
    dispatch(setHasFiscalPrinterUnsafe(hasFiscalPrinter))
  }
}

export function getPaymentMethods() {
  return (dispatch, getState) => dispatch(fetchPaymentMethods(getState().generalState.posId))
}

function fetchCountries(posid) {
  return (dispatch, getState) => fetch(general.API_URL_GET_COUNTRIES + '/' + getState().generalState.posId)
    .then(response => response.json())
    .then(json => dispatch(receiveCountries(posid, json)));
}

function fetchCustomerGroups(posid) {
  return (dispatch, getState) => fetch(general.API_URL_GET_CUSTOMERGROUPS + '/' + getState().generalState.posId)
    .then(response => response.json())
    .then(json => dispatch(receiveCustomerGroups(posid, json)));
}

function fetchLabels(posid) {
  return (dispatch, getState) => fetch(general.API_URL_GET_LABELS + '/' + getState().generalState.posId)
    .then(response => response.json())
    .then(json => dispatch(receiveLabels(posid,json)));
}

export function getCountries() {
  return (dispatch, getState) => dispatch(fetchCountries(getState().generalState.posId))
}

export function getCustomerGroups() {
  return (dispatch, getState) => dispatch(fetchCustomerGroups(getState().generalState.posId))
}

export function getLabels() {
  return (dispatch, getState) => dispatch(fetchLabels(getState().generalState.posId))
}

function receiveSystemSetting(settingKey, json) {
  return {
    type: types.RECEIVE_SYSTEM_SETTING,
    settingKey,
    value: json,
    receivedAt: Date.now()
  }
}

function fetchSystemSettingByKey(settingKey) {
  return dispatch => fetch(`${general.API_URL_GET_SYSTEM_SETTING_BY_KEY}${settingKey}`)
    .then(response => response.json())
    .then(json => dispatch(receiveSystemSetting(settingKey, json)));
}

export function getSystemSettingByKey(settingKey) {
  return (dispatch, getState) => dispatch(fetchSystemSettingByKey(settingKey))
}

function receiveDevices(pos, json) {
  return {
    type: types.RECEIVE_DEVICES,
    pos,
    devices: json,
    receivedAt: Date.now()
  }
}

function fetchDevices(posid) {
  return dispatch => fetch(general.API_URL_GET_DEVICES + posid)
    .then(response => response.json())
    .then(json => dispatch(receiveDevices(posid, json)));
}

export function getDevices() {
  return (dispatch, getState) => dispatch(fetchDevices(getState().generalState.posId))
}

function setMessageModalUnsafe(show, message) {
  return {
    type: types.SET_MESSAGE_MODAL,
    show,
    message
  }
}

export function setMessageModal(show, message) {
  return (dispatch) => {
    dispatch(setMessageModalUnsafe(show, message))
  }
}

function setSplashModalUnsafe(show, message, retry) {
  return {
    type: types.SET_SPLASH_MODAL,
    show,
    message,
    retry
  }
}

export function setSplashModal(show, message, retry) {
  return (dispatch) => {
    dispatch(setSplashModalUnsafe(show, message, retry))
  }
}

function setSelectModalUnsafe(listvalues, show, message, callback, callbackparams, showCancel, dispatch) {
  return {
    type: types.SET_SELECT_MODAL,
    listvalues,
    show,
    message,
    callback,
    callbackparams,
    showCancel,
    dispatch
  }
}

export function setSelectModal(listvalues, show, message, callback, callbackparams, showCancel = true) {
  return (dispatch) => {
    dispatch(setSelectModalUnsafe(listvalues, show, message, callback, callbackparams, showCancel, dispatch))
  }
}

function setConfirmModalUnsafe(message, confirm, cancel, confirmparam, cancelparam, dispatch) {
  return {
    type: types.SET_CONFIRM_MODAL,
    show: message !== '',
    message,
    confirm,
    cancel,
    confirmparam,
    cancelparam,
    dispatch
  }
}
export function setConfirmModal(message, confirm, cancel, confirmparam, cancelparam, dispatchEvent) {
  return (dispatch) => {
    let dispatchValue = dispatchEvent;
    if(dispatchValue === undefined){
      dispatchValue = dispatch
    } 
    dispatch(setConfirmModalUnsafe(message, confirm, cancel, confirmparam, cancelparam, dispatchValue));
  }
}

function getConfigurationStep(getState, configurationStepId) {
  let result = null;
  getState().generalState.configurationsteps.map(configurationStep => {
    if (configurationStep.ArticleConfigurationStepId === configurationStepId) {
      result = configurationStep;
    }
    return '';
  });
  return result;
}
function getConfigurationStepSelectedValue(input) {
  return {
    ParentArticleConfigurationStepValueId: input.ParentConfigurationStepValueId,
    ArticleConfigurationStepValueId: input.ConfigurationStepValueId,
    Description: input.ConfigurationStepValueDescription,
    ArticleConfigurationStepId: input.ConfigurationStepId,
    AllowMultiple: input.AllowMultiple
  };
}
function getConfigurationStepForModal(intput, order, selectedValueId, showStep, linktothepast) {
  return {
    id: linktothepast,
    configId: intput.ArticleConfigurationStepId,
    order: order + 0.1,
    description: intput.Description,
    stepdescription: intput.Description,
    selectedValueId: selectedValueId,
    active: false,
    values: intput.ArticleConfigurationStepValues,
    selectedValues: [],
    showstep: showStep,
    allowMultiple: intput.AllowMultiple
  }
}
function setConfigurationModalUnsafe(article, show, configurationSteps, lineid) {
  return {
    type: types.SET_CONFIGURATION_MODAL,
    article,
    show,
    configurationSteps,
    lineid
  }
}

export function reloadConfigurationModal(lineid, articleConfigurationStepId) {
  return async (dispatch, getState) => {
    const line = getState().receiptState.receipt.lines.find(l => l.id === lineid);
    const originalArticle = await dispatch(dataActions.getArticle(line.itemid));
    var tempArticle = $.extend(true, {}, originalArticle);

    tempArticle.Configurations = $.extend(true, [], line.configuration);

    tempArticle.Configurations.push(
      {
        ConfigurationStepId: articleConfigurationStepId,
        ConfigurationStepLinkId: 0,
        DefaultValueId: 0,
        Order: 0
      });

    dispatch(setConfigurationModal(tempArticle, line.configuration, line.id));
  }
}


export function setConfigurationModal(article, configurationSelectedValues, lineid, line) {
  return (dispatch, getState) => {
    const configurationSteps = [];
    let order = 1;
    let index = 0;

    article.Configurations.forEach(articleConfiguration => {
      const configurationStep = getConfigurationStep(getState, articleConfiguration.ConfigurationStepId);
      if (configurationStep !== null) {
        let defaultValue = 0;
        let selectedValues = [];
        
        configurationSelectedValues.forEach(configurationValue => {
          if (configurationValue.ConfigurationStepId === configurationStep.ArticleConfigurationStepId) {
            if (index < configurationSelectedValues.length) {
              if (configurationValue.ConfigurationStepValueId && configurationValue.ConfigurationStepValueId === configurationSelectedValues[index].ConfigurationStepValueId && selectedValues.length === 0) {
                selectedValues.push(getConfigurationStepSelectedValue(configurationValue));

                let previousConfigurationValue;
                let subOrder = order;
                configurationSelectedValues.forEach(subStepValue => {
                  if (subStepValue.ParentConfigurationStepValueId === configurationValue.ConfigurationStepValueId || (previousConfigurationValue && subStepValue.ParentConfigurationStepValueId === previousConfigurationValue.ConfigurationStepValueId)) {
                    previousConfigurationValue = subStepValue;

                    selectedValues.push(getConfigurationStepSelectedValue(subStepValue));
                    var subConfigurationStep = getConfigurationStep(getState, subStepValue.ConfigurationStepId);
                    if (subConfigurationStep !== null) {
                      subOrder += 0.1;
                      const subStep = getConfigurationStepForModal(subConfigurationStep, subOrder, subStepValue.ConfigurationStepValueId, false, articleConfiguration.ConfigurationStepLinkId);
                      subStep.parentstepid = configurationStep.ArticleConfigurationStepId;
                      configurationSteps.push(subStep);
                      index++;
                    }
                  }
                });
                
                defaultValue = configurationValue.ConfigurationStepValueId;
              }
            }
          }
        });

        const configurationStepForModal = getConfigurationStepForModal(configurationStep, order, defaultValue, true, articleConfiguration.ConfigurationStepLinkId);
        configurationStepForModal.selectedValues = selectedValues;
        configurationSteps.push(configurationStepForModal);

        index++;
        order++;
      }
    });

    configurationSteps.sort(function (a, b) { return a.order - b.order });
    let activeIsSet = false;
    configurationSteps.map(step => {

      if (step.selectedValueId === 0
        && !activeIsSet) {
        step.active = true;
        activeIsSet = true;
      }
      return '';
    });

    dispatch(setConfigurationModalUnsafe(article, true, configurationSteps, lineid));
  }
}

export function setConfigurationModalBySteps(configurationSteps) {
  return (dispatch, getState) => {
    const modal = getState().generalState.modal.configurationModal;
    dispatch(setConfigurationModalUnsafe(modal.article, true, configurationSteps, modal.lineid));
  }
}
export function hideConfigurationModal() {
  return (dispatch, getState) => {
    const modal = getState().generalState.modal.configurationModal;
    dispatch(setConfigurationModalUnsafe(modal.article, false, modal.configurationSteps, modal.lineid));
  }
}

function updateStatusUnsafe(itemid, printerstatus, statusmsg) {
  return {
    type: types.PRINTER_UPDATE_STATUS,
    itemid,
    status: printerstatus,
    statusmsg
  }
}

export function updateStatus(itemid, printerstatus, statusmsg) {
  return (dispatch, getState) => {
    dispatch(updateStatusUnsafe(itemid, printerstatus, statusmsg))
    if (getState().layoutState.functionbartype === general.FUNCTIONBAR_STATUS) {
      dispatch(setFunctionBarType(general.FUNCTIONBAR_STATUS))
    }
    if (printerstatus > status.PRINTER_OK) {
      dispatch(setMessageModal(true, `${dispatch(dataActions.getTranslation(resource.ERROR_WHILE_PRINTING))}\n${statusmsg}`));
    }
  }
}

function receivePosList(json) {
  return {
    type: types.RECEIVE_POSLIST,
    json
  }
}

function fetchPosList() {
  return dispatch => fetch(general.API_URL_POSLIST)
    .then(response => response.json())
    .then(json => dispatch(receivePosList(json)));
}

export function getPosList() {
  return (dispatch) => dispatch(fetchPosList())
}

function dummyCheckLicenseUnsafe(licensestatus) {
  return {
    type: types.DUMMY_CHECK_LICENSE,
    licensestatus
  }
}

export function dummyCheckLicense() {
  let result = true;
  return dispatch => fetch(general.API_URL_DUMMY_CHECK_LICENSE)
    .then(checkStatus)
    .then(response => {
      if (response.status === 423) {
        result = false;
      }
    })
    .then(() => {
      dispatch(dummyCheckLicenseUnsafe(result));
    });
}

function receiveLicenses(json) {
  return {
    type: types.GET_LICENSES,
    blackbox: json.Blackbox
  }
}

export function getLicenses() {
  return dispatch => fetch(general.API_URL_GET_LICENSES)
    .then(checkStatus)
    .then(response => response.json())
    .then(json => dispatch(receiveLicenses(json)))
}

function receiveDaysTillExpired(json) {
  var result = {
    type: types.GET_DAYSTILLEXPIRED,
    daysLeft: json
  };
  return result;
}

export function getDaysTillExpired() {
  return dispatch => fetch(general.API_URL_GET_DAYSTILLEXPIRED)
    .then(response => response.json())
    .then(json => dispatch(receiveDaysTillExpired(json)))
}


function receiveBlackboxStatus(json) {
  return {
    type: types.GET_BLACKBOX_STATUS,
    status: json
  }
}

export function getBlackboxStatus(posid, userid) {
  return (dispatch, getState) => {
    if (posid <= 0 || !userid) {
      dispatch(receiveBlackboxStatus(true));
    } else {
      fetch(general.API_URL_GET_BLACKBOX + posid)
        .then(checkStatus)
        .then(response => response.json())
        .then(json => dispatch(receiveBlackboxStatus(json)))
        .catch(() => {
          dispatch(receiveBlackboxStatus({ ErrorCode: 0, ErrorMessage: dispatch(dataActions.getTranslation(resource.MODAL_NO_BLACKBOX_CONNECTION)) }));
        })
    }
  }
}

export function resetFiscalPrinter() {
  return (dispatch, getState) => {
    var posID = getState().generalState.posId;
    fetch(general.API_RESET_FISCALPRINTER + posID)
      .then(response => response.json())
      .then(response => {
        if (response === 2) {
          dispatch(setMessageModal(true, `${dispatch(dataActions.getTranslation(resource.RESET_FISCALPRINTER))}\n${dispatch(dataActions.getTranslation(resource.TECHNICAL_ERROR))}`))
        } else {
          dispatch(setMessageModal(true, `${dispatch(dataActions.getTranslation(resource.RESET_FISCALPRINTER))}\n${dispatch(dataActions.getTranslation(resource.STATUS_OK))}`))
        }
      })
  }
}

function receiveGetConfigurationSteps(json) {
  return {
    type: types.LIST_CONFIGURATIONS,
    steps: json
  }
}
function fetchConfigurationSteps() {
  return dispatch => fetch(general.API_URL_LIST_CONFIGURATION)
    .then(response => response.json())
    .then(json => dispatch(receiveGetConfigurationSteps(json)));
}
export function getConfigurationSteps() {
  return (dispatch) => dispatch(fetchConfigurationSteps())
}

function receiveGetArticles(json) {
  return {
    type: types.LIST_ARTICLES,
    articles: json
  }
}
function fetchArticles(posId) {
  return dispatch => fetch(general.API_URL_LIST_ARTICLES + posId)
    .then(response => response.json())
    .then(json => dispatch(receiveGetArticles(json)));
}
export function getArticles() {
  return (dispatch, getState) => dispatch(fetchArticles(getState().generalState.posId))
}

function receivePriceLists(json) {
  return {
    type: types.LIST_PRICELIST,
    pricelists: json
  }
}

function fetchPriceLists() {
  return dispatch => fetch(general.API_URL_LIST_PRICELIST)
    .then(response => response.json())
    .then(json => dispatch(receivePriceLists(json)));
}

export function getPriceLists() {
  return (dispatch) => dispatch(fetchPriceLists());
}

export function setKeyFunctionExecuted(functioncode) {
  return {
    type: types.SET_KEYFUNCTION_EXECUTED,
    functioncode
  }
}

function getVersionUnsafe(version) {
  return {
    type: types.SET_VERSION,
    version
  }
}

export function getVersion() {
  return dispatch =>
    fetch(general.API_URL_GET_VERSION)
      .then(response => response.json())
      .then(json => {
        dispatch(getVersionUnsafe(json.Version))
      });

}

export function setUniqueId(uniqueid) {
  return {
    type: types.SET_UNIQUEID,
    uniqueid
  }
}
export function getUniqueId(posId) {
  return (dispatch) => {
    let uniqueId = cookie.load(general.COOKIE_POS_UNIQUEID, { path: '/' });
    if (!uniqueId) {
      fetch(general.API_URL_GET_ID + posId)
        .then(response => response.json())
        .then(json => {
          if (json.UniqueId && json.UniqueId !== "") {
            cookie.save(general.COOKIE_POS_UNIQUEID, json.UniqueId, { path: '/', expires: new Date(2999, 1, 1, 0, 0, 0, 0) });
            dispatch(setUniqueId(json.UniqueId));
          }
        });
    } else {
      dispatch(setUniqueId(uniqueId));
    }
  }
}

export function setBlackboxReceiptId(receiptId) {
  return {
    type: types.SET_BLACKBOX_RECEIPTID,
    receiptId
  }
}

export function setPosPricelist(pricelistid) {
  return {
    type: types.SET_POS_PRICELIST,
    pricelistid
  }
}

export function log(msg, isError) {
  return (dispatch, getState) => {
    const posId = getState().generalState.posId;
    const userId = getState().loginState.loggedin.id;
    const posDeviceGuid = getState().generalState.uniqueid;

    const data = {
      PosId: posId,
      UserId: userId,
      PosDeviceGuid: posDeviceGuid,
      Message: msg,
      IsError: isError
    };

    fetch(general.API_URL_POSLOG, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': posId,
        'Context': 'generalActions:log' 
      },
      body: JSON.stringify(data)
    });
  }
}

function receivePosDefaultChangePayment(json) {
  return {
    type: types.SET_POS_DEFAULT_PAYMENT,
    defaultChangePaymentId: json
  }
}

function fetchPosDefaultChangePayment(posid) {
  return dispatch => fetch(general.API_URL_POS_DEFAULT_CHANGE_PAYMENT + posid)
    .then(response => response.json())
    .then(json => dispatch(receivePosDefaultChangePayment(json)));
}

export function getPosDefaultChangePayment(posid) {
  return (dispatch, getState) => dispatch(fetchPosDefaultChangePayment(posid));
}

export function setRoundAmount(roundAmount) {
  return {
    type: types.SET_ROUND_AMOUNT,
    roundAmount
  }
}

export function setPosGraphicDisplay(graphicdisplay) {
  return {
    type: types.SET_POS_GRAPHIC_DISPLAY,
    graphicdisplay
  }
}

export function isValidDate(dateString){
  // First check for the pattern
  if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)){
    return false;
  }

  // Parse the date parts to integers
  var parts = dateString.split("/");
  var day = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[2], 10);

  // Check the ranges of month and year
  if(year < 1000 || year > 3000 || month === 0 || month > 12){
    return false;
  }

  var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];
  // Adjust for leap years
  if(year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)){
    monthLength[1] = 29;
  }

  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1];
}

export function parseDate(dateString){
  if(!isValidDate(dateString)){
    return null;
  }
  // Parse the date parts to integers
  var parts = dateString.split("/");
  var day = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10);
  var year = parseInt(parts[2], 10);
  
  var tsDate = new Date(year, month - 1, day);
  return new Date(Date.UTC(tsDate.getFullYear(), tsDate.getMonth(), tsDate.getDate(),0,0));         
}

export function initializeBroadcastChannel(message){

  const broadcastChannel = new BroadcastChannel('tab');
    window.channel = broadcastChannel;
    broadcastChannel.postMessage("new-tab");
    broadcastChannel.onmessage = msg => {
        if(msg === "new-tab"){
          window.channel.postMessage("close-tab");
        }else if(msg === "close-tab"){
          window.noninteractive = true;
          window.dispatchEvent(new Event('resize'));
        }
    };
}

export function unloadBroadcastChannel(){
  window.channel.close();
}


// WEBPACK FOOTER //
// src/actions/generalActions.js